import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
//import { AngularFireMessaging } from '@angular/fire/messaging';
import { PHBHPListApiService } from '../ph-bhp-listapi.service';
import { DeviceInfo } from '../Models/DeviceInfo';

@Injectable({
  providedIn: 'root'
})
export class PhBhpNotificationService {

  //currentMessage = new BehaviorSubject(null);
  constructor(/*private angularFireMessaging: AngularFireMessaging,*/ private service: PHBHPListApiService) { 
    /*this.angularFireMessaging.messaging.subscribe(
      (_messaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      });*/
  }

  requestPermission(userData) {
    return /*this.angularFireMessaging.requestToken.subscribe(
      (token) => {
      
        this.registerDevice(userData, token);
      },
      (err) => {
        //console.error('Unable to get permission to notify.', err);
      }
    );*/
  }

  registerDevice(userData, token) {
    const data = {
      isDesktpo: true, 
      deviceToken: token,
      userId: userData.userId,
      roleId: userData.roleName.roleId
    };
    this.service.CreateDeviceInfo(data).subscribe((res: Array<DeviceInfo> = []) => {
     
    })
  }

  receiveMessage() {
    /*this.angularFireMessaging.messages.subscribe(
      (payload) => {
        
      })*/
  }

}
